var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card shadow-sm" }, [
    _c("img", {
      staticClass: "card-img-top rounded",
      attrs: { src: _vm.post.thumbnail_url },
      on: {
        load: function($event) {
          _vm.imageLoaded = true
        }
      }
    }),
    _vm._v(" "),
    !_vm.imageLoaded
      ? _c(
          "div",
          {
            staticClass: "text-center bg-light",
            staticStyle: { "padding-top": "80px", "padding-bottom": "80px" }
          },
          [
            _c("i", {
              staticClass: "mdi mdi-spin mdi-autorenew mdi-36px text-primary"
            })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("h3", { staticClass: "oswald" }, [
        _vm._v("\n            " + _vm._s(_vm.post.title) + "\n        ")
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.isNew
          ? _c("span", { staticClass: "badge badge-primary badge-sm" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("pages.locker.my_blog.new")) +
                  "\n            "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "text-muted font-weight-bolder mt-2 text-small" },
          [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$date(_vm.post.creted_at).format("DD.MM.YYYY")) +
                "\n            "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mt-4 text-secondary" }, [
        _vm._v(
          "\n            " + _vm._s(_vm.post.contents_preview) + "\n        "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-5" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn btn-outline-dark",
              attrs: {
                to: {
                  name: "locker.my-blog.view",
                  params: { slug: _vm.post.slug }
                }
              }
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("pages.locker.my_blog.read_more")) +
                  "\n            "
              )
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }